import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import firebase from './Firebase';
import { getDatabase, ref, push, remove, child, onValue } from 'firebase/database';
import { useEffect } from 'react';
import { uuidv4 as uniqueId } from '@firebase/util';


const City = (props) => {
    let newObj = props.data;
    newObj = newObj.replace("@", "a");
    newObj = newObj.replace(".", "dot");

    const [city, setCity] = useState('');
    const [records, setRecords] = useState([]);
    const [feedback, setFeedback] = useState('');

    const cityHandler = (evt) => {
        setCity(evt.target.value);
    }

    const addHandler = () => {
        console.log("add");
        axios.get(`https://api.openweathermap.org/data/2.5/weather?q= ${city}&appid=795a2bf2f4aab15cd827770a331c97ec&units=metric`)
            .then((response) => {
                console.log(response.data);
                const data = response.data;
                const name = data.name;
                const temp = data.main.temp;
                const icon = data.weather[0].icon;
                const ic = `http://openweathermap.org/img/wn/${icon}@2x.png`;
                const wind = data.wind.speed;
                const description = data.weather[0].description;
                const country = data.sys.country;
                const humidity = data.main.humidity;
                const db = getDatabase();
                const r = ref(db, newObj);
                push(r, { name: name, temp: temp, icon: ic, country: country, wind: wind, description: description, humidity: humidity })
                // setCity('');
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const feedHandler = (evt) => {
        console.log("fee");
        setFeedback(evt.target.value);
    }
    
    const sendFeedbackHandler = ()=>{
        console.log("sendFeedbackHandler");
        axios.get(`https://api.openweathermap.org/data/2.5/weather?q= ${city}&appid=795a2bf2f4aab15cd827770a331c97ec&units=metric`)
            .then((response) => {
                console.log(response.data);
                const data = response.data;
                const name = data.name;
                const temp = data.main.temp;
                const icon = data.weather[0].icon;
                const ic = `http://openweathermap.org/img/wn/${icon}@2x.png`;
                const wind = data.wind.speed;
                const description = data.weather[0].description;
                const country = data.sys.country;
                const humidity = data.main.humidity;
                const db = getDatabase();
                const r = ref(db, newObj);
                push(r, { name: name, temp: temp, icon: ic, country: country, wind: wind, description: description, humidity: humidity,feedback:feedback })
                setCity('');
                setFeedback('') 
            })
            .catch((error) => {
                console.log(error);
            })
    } 

    const deleteHandler = (v) => {
        const db = getDatabase();
        const r = ref(db, newObj);
        remove(child(r, v));
    }

    useEffect(() => {

        const db = getDatabase();
        const r = ref(db, newObj);
        onValue(r, snapshot => {
            const data = snapshot.val();
            const rcds = [...records];
            for (let v in data) {
                rcds.push({ v, ...data[v] });
            }
            setRecords(rcds);
        });
    }, [])



    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className='text-center mb-4'>
                            <input type="text" placeholder='Enter City Name' autoFocus className=' text-center p-2 rounded-3' value={city} onChange={cityHandler} /> &nbsp;
                            <button onClick={addHandler} className="btn btn-success ">Add</button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {
                        records.map((row, i) => {
                            return (
                                <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={i}>
                                    <div className=" box border border-2 border-dark text-center rounded-3 pt-2">
                                        <h5>{row.name}</h5>
                                        <p><img src={row.icon} alt="icon" /></p>
                                        <p><b>Temp:</b> {row.temp} &deg;C</p>
                                        <p><b>Wind:</b> {row.wind} m/s</p>
                                        <p><b>Humidity:</b> {row.humidity} %</p>
                                        <p><b>Description:</b> {row.description}</p>
                                        <p><b>Country:</b> {row.country}</p>
                                        <div className='dltBtn'>
                                            <button onClick={() => deleteHandler(row.v)}>X</button>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            )
                        })
                    }
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="feedback w-100 ">
                            <textarea cols="30" rows="3" className=' w-100  rounded-3 border border-2 border-success fs-3' onChange={feedHandler} value={feedback} placeholder='Enter Your Feedback Here...'></textarea>&nbsp;
                            <div className=' d-grid mb-4'>
                                <button className='btn btn-outline-success border border-2 border-success rounded-3' onClick={sendFeedbackHandler}><b>Send Feedback</b></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default City;